import { IsBoolean, IsNotEmpty, IsNumber, IsString } from "class-validator";

export class CityStatsDataDto {
  population: number;

}